import type { ColumnDef } from '@tanstack/vue-table'
import { type ConnectedAccounts } from 'pejer/src/tables/ConnectedAccounts'

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.

export const connectedAccountsColumns: ColumnDef<ConnectedAccounts.ListItem>[] = [
  {
    accessorKey: 'connectedAccountID',
    header: 'ID',
    meta: {
      hide_default: true,
    },
  },
  {
    accessorKey: 'businessName',
  },
  {
    accessorKey: 'business_TaxID',
  },
  {
    accessorKey: 'name',
  },
  {
    accessorKey: 'email',
  },
  {
    accessorKey: 'paymentCount',
  },
  {
    accessorKey: 'availableForPayouts',
  },
  {
    accessorKey: 'info',
  },
  // {
  //   accessorKey: 'revenueSum',
  // },
  {
    accessorKey: 'paidOutSum',
    meta: {
      hide_default: true,
    },
  },
  {
    accessorKey: 'balance',
  },
  {
    accessorKey: 'payoutsEnabled',
  },
  {
    accessorKey: 'insertTime',
    header: 'Created',
    meta: {
      sortable: true,
    },
  },
  {
    id: 'actions',
  },
]
